// ES
export const calendarsChatbotHc = {
  monthlyCalendar: {
    pricesTitle: "Precios dinámicos",
    prices: "Precios",
    noPropertiesAvailable: "Sin propiedades disponibles",
    noPropertiesFound: "No se encontraron propiedades",
    minStayShort: "mín. {n}n",
    available: "Disponible",
    notAvailable: "No disponible",
    closed: "Cerrado",
    loading: "Cargando…",
    showMoreMonths: "Mostrar más meses",
    from: "Desde",
    to: "Hasta",
    nightsLabelOne: "{n} noche",
    nightsLabelMany: "{n} noches",
    whatToDo: "¿Qué quieres hacer?",
    close: "Cerrar",
    open: "Abrir",
    price: "Precio",
    minStay: "Est. mínima",
    closeReasonPlaceholder: "Motivo del cierre (opcional)",
    openHint: "Se reabrirán las fechas seleccionadas (se quita el bloqueo).",
    nightsWord: "noches",
    clearSelection: "Limpiar selección",
    past: "Pasada",
    guestOne: "huésped",
    guestMany: "huéspedes",
    perNight: "/ noche",
    noName: "Sin nombre",
    channelDirect: "Directa",
    ownerBlockComment: "Bloqueo por el propietario",
    prepTime: "Tiempo de preparación",
    sameDayCutoff: "Cierre del mismo día",
    linkedClosed: "Venta completa",
    linkedClosedInfo: "Cerrado por la venta del apartamento completo ({motivo}). Se abrirá solo si esa reserva se cancela o cambia de fechas.",
    alsoLinked: "también cerrado por la venta del apartamento completo ({motivo})",
    applyClose: "Cerrar fechas",
    applyOpen: "Abrir fechas",
    applyPrice: "Guardar precio",
    applyMinStay: "Guardar estancia mínima",
    apply: "Aplicar",
    processing: "Procesando…",
    closingDates: "Cerrando fechas…",
    openingDates: "Abriendo fechas…",
    priceModeLabel: "Forma de precio",
    priceModeFixed: "Fijo",
    priceModePercent: "%",
    priceModeAmount: "Importe",
    percentPlaceholder: "Ej. 20",
    amountPlaceholder: "Ej. 10",
    percentHint: "Cada noche se recalcula sobre su propio precio. Con − baja.",
    amountHint: "Se suma a lo que ya vale cada noche. Con − baja.",
    invalidPrice: "Introduce un precio válido.",
    changingPrice: "Cambiando precio por noche…",
    priceUpdated: "Precio actualizado correctamente.",
    priceUpdateError: "No se pudo actualizar el precio.",
    minStayMin: "La estancia mínima debe ser al menos 1 noche.",
    changingMinStay: "Cambiando estancia mínima…",
    minStayUpdated: "Estancia mínima actualizada correctamente.",
    minStayUpdateError: "No se pudo actualizar la estancia mínima.",
    unknownError: "Error desconocido",
  },
  calendar: {
    channelDirect: "Directa",
    searchMin2: "Escribe al menos 2 caracteres para buscar",
    searchNoResults: "No se encontraron reservas para esa búsqueda",
    searchError: "Error al buscar reservas",
    processing: "Procesando…",
    ownerBlockComment: "Bloqueo por el propietario",
    cutoffTip: "Cierre de venta del mismo día a las {time}",
    nightsLabelOne: "{n} noche",
    nightsLabelMany: "{n} noches",
    turnoverBefore: "Tiempo de preparación: reserva {nights} antes de cada entrada",
    turnoverAfter: "Tiempo de preparación: reserva {nights} desde cada salida",
    turnoverBoth: "Tiempo de preparación: reserva {nights} antes de la entrada y desde la salida",
    selectAtLeastOneProperty: "Selecciona al menos un alojamiento.",
    selectAtLeastOneDate: "Selecciona al menos una fecha efectiva para aplicar los cambios.",
    preparingOps: "Preparando {total} operaciones...",
    applyingOps: "Aplicando {index} de {total}: {name}",
    unknownError: "Error desconocido",
    couldNotSaveChanges: "No se pudieron guardar los cambios.",
    bulkApplyError: "No se pudieron aplicar los cambios masivos. {message}",
    opsApplied: "Se aplicaron {success} de {total} operaciones.",
    opsSkipped: "Se omitieron {skipped} fechas con reservas confirmadas.",
    opsFailed: "Fallaron {failed} operaciones.",
    bulkApplied: "Edición masiva aplicada en {count} alojamientos.",
    couldNotOpenDate: "No se pudo abrir la fecha",
    datesOpened: "Fechas abiertas",
    closeUpdated: "Cierre actualizado",
    todayLabel: "Hoy",
    closed: "Cerrado",
    linkedClosed: "Venta completa",
    linkedClosedInfo: "Cerrado por la venta del apartamento completo ({motivo}). Se abrirá solo si esa reserva se cancela o cambia de fechas.",
    alsoLinked: "también cerrado por la venta del apartamento completo ({motivo})",
    closingDates: "Cerrando fechas…",
    couldNotCloseDates: "No se pudieron cerrar las fechas",
    clearFiltersTitle: "Limpiar filtros",
    noPropertiesAvailable: "Sin propiedades disponibles",
    noPropertiesFound: "No se encontraron propiedades",
    dynamicPricesTitle: "Precios dinámicos",
    prices: "Precios",
    viewWide: "Vista amplia",
    viewCompact: "Vista compacta",
    viewNormal: "Vista normal",
    viewFull: "Ver completo",
    searchBookingTitle: "Buscar reserva",
    searchBookingPlaceholder: "Buscar reserva…",
    search: "Buscar",
    resultsSelectOne: "{count} resultados — selecciona uno:",
    bulkEdit: "Edición masiva",
    goToTodayTitle: "Ir a hoy",
    showHeader: "Mostrar cabecera",
    configArrivalDeparture: "Configurar reglas de llegada y salida",
    notAvailable: "No disponible",
    extension: "Ampliación",
    lateCheckoutUntil: "Salida tardía hasta las {time}",
    aiRequests: "Recepción IA",
    guestComments: "Observaciones del huésped",
    internalNotes: "Notas internas",
    extrasTitle: "Extras contratados",
    extrasPending: "Pendiente de confirmar",
    reqArrivalTitle: "Hora de llegada",
    reqAt: "a las {time}",
    reqUntil: "hasta las {time}",
    reqNights: "Noches extra: {n}",
    reqPending: "Pendiente",
    reqConfirmed: "Confirmada",
    reqPaid: "Pagada",
    reqOffered: "Ofrecida",
    reqPrioritised: "Priorizada",
    pendingAmount: "Pendiente:",
    noticesColumn: "Avisos",
    callsTitle: "Llamadas",
    callsCount: "Llamadas: {n}",
    extensionPaid: "Ampliación pagada",
    listCheckin: "Entrada",
    listCheckout: "Salida",
    priceOriginal: "Reserva original",
    priceExtension: "Ampliación",
    priceTotal: "Total",
    paymentInProcess: "Pago en proceso",
    overbooking: "Overbooking",
    noAccommodationsFound: `No se encontraron alojamientos con "{term}".`,
    past: "Pasada",
    paymentInProcessLower: "pago en proceso",
    pendingApproval: "pendiente de aprobación",
    pendingApprovalTitle: "Pendiente de aprobación",
    guestOne: "huésped",
    guestMany: "huéspedes",
    perNight: "/ noche",
  },
  tableFilters: {
    filterByDate: "Filtrar por fecha desde - hasta",
    filterByCountry: "Filtrar por país",
    all: "Todos",
    countrySpain: "España",
    countryColombia: "Colombia",
    countryBrazil: "Brazil",
    filterByState: "Filtrar por estado",
    allStates: "Todos los estados",
    stateDemo: "Versión demo",
    stateSubscribed: "Suscritos",
    stateNotSubscribed: "Sin suscribir",
    searchRecords: "Buscar en los registros",
  },
  chatbotPageIndex: {
    aiAgentBadge: "Agente IA",
    planFeatureHint: "Función disponible con plan de pago.",
    otaAgentTitle: "Agente IA para OTAs",
    otaAgentHint: "Activa para que el agente responda automáticamente mensajes de Booking, Airbnb y otras OTAs.",
    otaRequiresWhatsapp: "Requiere el Agente IA de WhatsApp activo.",
    guardNotice: "Con el Agente IA desactivado, el chat también pasa a <strong>respuesta manual</strong> automáticamente. Los switches por conversación quedarán bloqueados hasta que lo reactives.",
    configureBasic: "Configurar agente IA básico",
    configureAdvanced: "Configurar agente IA avanzado",
    comingSoon: "Próximamente",
    detailFallback: "Detalle",
    errorLoadListingConfig: "No se pudo cargar la configuración del listing",
    errorSaveChange: "Error al guardar el cambio",
    otaAgentActivated: "Agente IA para OTAs activado",
    otaAgentDeactivated: "Agente IA para OTAs desactivado",
  },
  chatbotIndex: {
    accommodationFallback: "Alojamiento",
    defaultHandoffSupportLine: "\nSi necesitas atención rápida, contáctanos al {phone} 📞",
    defaultHandoffMessage: "Hola 😊 En este momento no tengo esa información, pero un miembro de nuestro equipo te atenderá pronto 🙌{suffix}\n¡Estamos pendientes de ti durante toda tu estadía! 🏡✨",
    silentModeMessage: "No se enviará respuesta automática al huésped. El sistema seguirá notificando al operador para que pueda continuar la conversación.",
    statusNoGuestReply: "Sin respuesta al huésped",
    statusUsingCustom: "Usando mensaje personalizado",
    statusUsingDefault: "Usando mensaje por defecto",
    helperSilent: "El huésped no recibirá respuesta automática cuando el Agente IA no sepa qué contestar, pero el operador sí recibirá la notificación para tomar la conversación.",
    helperCustom: "El sistema traducirá este mensaje personalizado automáticamente al idioma del huésped.",
    helperHasCustom: "Tienes un mensaje personalizado guardado, pero ahora mismo el sistema seguirá usando el mensaje por defecto.",
    helperDefault: "Si creas un mensaje maestro, podrás activarlo aquí y el sistema lo traducirá automáticamente al idioma del huésped.",
    sourceSilent: "Silencioso",
    sourceCustom: "Personalizado",
    sourceDefault: "Predeterminado",
    defaultBotName: "Mi Asistente Virtual",
    errorLoadBotName: "No se pudo cargar el nombre del asistente.",
    errorLoadHandoff: "No se pudo cargar el mensaje de derivación.",
    botNameUpdated: "Nombre del asistente actualizado.",
    errorSaveBotName: "No se pudo guardar el nombre del asistente.",
    masterMessageUpdated: "Mensaje maestro actualizado.",
    errorSaveMaster: "No se pudo guardar el mensaje maestro.",
    warnCreateCustomFirst: "Primero crea un mensaje personalizado antes de activarlo.",
    modeCustomActivated: "Ahora se usará el mensaje personalizado.",
    modeSilentActivated: "El bot quedará en silencio cuando no sepa responder, pero el operador seguirá siendo notificado.",
    modeDefaultActivated: "Ahora se usará el mensaje por defecto.",
    errorUpdateActiveMessage: "No se pudo actualizar el mensaje activo.",
    warnWriteQuestion: "Escribe una pregunta antes de guardar.",
    questionCreated: "Pregunta creada correctamente.",
    errorAddQuestion: "No se pudo agregar la pregunta.",
    botNamePlaceholder: "Nombre del asistente",
    handoffRowTitle: "Mensaje cuando el agente no sabe responder",
    customize: "Personalizar",
    expandAria: "Expandir",
    handoffSubtitle: "Este texto se enviará cuando el Agente IA no encuentre la respuesta en los facts, la memoria o las FAQs.",
    modeDefaultTitle: "Mensaje por defecto",
    modeDefaultDesc: "Usa el mensaje estándar del sistema con el teléfono de soporte.",
    modeCustomTitle: "Mensaje personalizado",
    modeCustomDescActive: "Activa el texto personalizado que guardaste en el modal.",
    modeCustomDescEmpty: "Aún no has creado un mensaje personalizado.",
    modeSilentTitle: "No responder al huésped",
    modeSilentDesc: "El huésped no recibe mensaje automático, pero el operador sí será notificado para continuar la conversación.",
    loadingMessage: "Cargando mensaje...",
    masterMessage: "Mensaje maestro",
    newQuestionTitle: "Nueva pregunta",
    newQuestionSubtitle: "Crea una nueva pregunta frecuente para que el Agente IA pueda responderla con más precisión.",
    guestQuestionLabel: "Pregunta del huésped",
    questionPlaceholder: "Ej. ¿A qué hora es el check-in?",
    questionHelp: "Consejo: escribe la pregunta como la haría un huésped real.",
    cancel: "Cancelar",
    saveQuestion: "Guardar pregunta",
    handoffKicker: "Respuesta de derivación",
    handoffModalTitle: "Personalizar mensaje maestro",
    handoffModalSubtitle: "Escribe un solo mensaje en español. El sistema lo traducirá automáticamente y responderá según el idioma en que esté hablando el huésped.",
    masterToolbarInfo: "Puedes usar emojis y un tono cercano, igual que en tus otros mensajes automáticos.",
    emojiSearchPlaceholder: "Buscar emoji...",
    masterTextareaPlaceholder: "Escribe aquí el mensaje maestro. Puedes usar emojis y un tono cálido para el huésped.",
    masterHint: "Recomendación: escribe el mensaje en español con el tono exacto que quieres comunicar. El sistema lo adaptará automáticamente al idioma del huésped.",
    viewDefaultMessage: "Ver mensaje por defecto",
    saveMessage: "Guardar mensaje",
    newButton: "Nueva",
    emojiButton: "Emoji",
  },
  messageAccountDemo: {
    usingDemo: "Estás utilizando la versión demo",
    ofThePlatform: "de la plataforma",
    trialHave: "¡Aún tienes",
    trialDaysToEnjoy: "días para disfrutar todas las funcionalidades!",
    trialSubscribeNow: "Suscríbete ahora y sigue gestionando tus alojamientos sin interrupciones.",
    subscribeNowLabel: "Suscríbete ahora",
  },
};
